"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.DesignerCatalogResourcesBuilder = exports.DesignerCatalogResourcesConfiguration = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var core_common_domain_2 = require("@jewelutions/core-common-domain");
var DesignerCatalogResourcesConfiguration = /** @class */ (function () {
    function DesignerCatalogResourcesConfiguration() {
    }
    DesignerCatalogResourcesConfiguration.ALL = {
        includeHdri: true,
        includeFonts: true,
        includeSymbols: true,
        includePieces: true,
        includePieceCads: true,
        includeAccessories: true,
        includeAccessoryCads: true
    };
    DesignerCatalogResourcesConfiguration.ALL_EXCEPT_CADS = {
        includeHdri: true,
        includeFonts: true,
        includeSymbols: true,
        includePieces: true,
        includePieceCads: false,
        includeAccessories: true,
        includeAccessoryCads: false
    };
    return DesignerCatalogResourcesConfiguration;
}());
exports.DesignerCatalogResourcesConfiguration = DesignerCatalogResourcesConfiguration;
var DesignerCatalogResourcesBuilder = /** @class */ (function () {
    function DesignerCatalogResourcesBuilder(designerCatalogId, inputMedias, outputMedias, configuration) {
        this.inputMedias = [];
        this.outputMedias = [];
        this.designerCatalogId = designerCatalogId;
        this.inputMedias = inputMedias;
        this.outputMedias = outputMedias;
        this.configuration = configuration;
    }
    DesignerCatalogResourcesBuilder.initialiseWithDesignerCatalogResources = function (designerCatalogResources) {
        return new DesignerCatalogResourcesBuilder(designerCatalogResources.id, designerCatalogResources.resources, designerCatalogResources.resources, designerCatalogResources.configuration);
    };
    DesignerCatalogResourcesBuilder.initialiseWithDesignerCatalog = function (designerCatalog, configuration) {
        if (configuration === void 0) { configuration = DesignerCatalogResourcesConfiguration.ALL; }
        var inputMedias = [];
        if (configuration.includeHdri) {
            inputMedias.push(designerCatalog.designerApplicationConfiguration.viewer3DEnvironment.viewer3DConfig
                .viewerIblEnvironmentConfig.hdri);
        }
        if (configuration.includeFonts) {
            for (var _i = 0, _a = designerCatalog.availableFonts; _i < _a.length; _i++) {
                var font = _a[_i];
                inputMedias.push(font.media);
            }
        }
        if (configuration.includeSymbols) {
            for (var _b = 0, _c = designerCatalog.availableSymbols; _b < _c.length; _b++) {
                var symbol = _c[_b];
                inputMedias.push(symbol.boundingShape.polyShape.mediaDefined);
                inputMedias.push(symbol.media);
            }
        }
        if (configuration.includePieces) {
            for (var _d = 0, _e = designerCatalog.availablePieces; _d < _e.length; _d++) {
                var piece = _e[_d];
                for (var _f = 0, _g = piece.models; _f < _g.length; _f++) {
                    var pieceModel = _g[_f];
                    if (configuration.includePieceCads) {
                        inputMedias.push(pieceModel.cadFile);
                    }
                    inputMedias.push(pieceModel.icon);
                    for (var _h = 0, _j = pieceModel.editableAreas; _h < _j.length; _h++) {
                        var editableArea = _j[_h];
                        inputMedias.push(editableArea.shape.polyShape.mediaDefined);
                    }
                    for (var _k = 0, _l = pieceModel.editableSides; _k < _l.length; _k++) {
                        var editableSide = _l[_k];
                        inputMedias.push(editableSide.shape.polyShape.mediaDefined);
                    }
                }
            }
        }
        if (configuration.includeAccessories) {
            for (var _m = 0, _o = designerCatalog.availableAccessories; _m < _o.length; _m++) {
                var accessory = _o[_m];
                for (var _p = 0, _q = accessory.models; _p < _q.length; _p++) {
                    var accessoryModel = _q[_p];
                    if (configuration.includeAccessoryCads) {
                        inputMedias.push(accessoryModel.cadFile);
                    }
                    inputMedias.push(accessoryModel.icon);
                }
            }
        }
        return new DesignerCatalogResourcesBuilder(designerCatalog.id, inputMedias, [], configuration);
    };
    DesignerCatalogResourcesBuilder.prototype.retrieveContent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, input, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.outputMedias = [];
                        _i = 0, _a = this.inputMedias;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        input = _a[_i];
                        return [4 /*yield*/, core_common_logic_1.CommonLogic.retrieveUrlContent(input.url)];
                    case 2:
                        result = _b.sent();
                        if (!result.success)
                            throw new core_common_domain_2.Exception("Cannot retrieve url " + input.url);
                        this.outputMedias.push(core_common_domain_1.MediaBuilder.initialiseWithUrlAndContentBase64(input.url, core_common_logic_1.CommonLogic.Base64.fromUint8Array(new Uint8Array(result.content)), input.contentType).build());
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, this];
                }
            });
        });
    };
    DesignerCatalogResourcesBuilder.prototype.transformUrls = function (oldToNewUrlMappings) {
        var newInputMedias = [];
        for (var _i = 0, _a = this.inputMedias; _i < _a.length; _i++) {
            var inputMedia = _a[_i];
            if (oldToNewUrlMappings.has(inputMedia.url)) {
                newInputMedias.push(__assign(__assign({}, inputMedia), { url: oldToNewUrlMappings.get(inputMedia.url) }));
            }
        }
        this.inputMedias = newInputMedias;
        var newOutputMedias = [];
        for (var _b = 0, _c = this.outputMedias; _b < _c.length; _b++) {
            var outputMedia = _c[_b];
            if (oldToNewUrlMappings.has(outputMedia.url)) {
                newOutputMedias.push(__assign(__assign({}, outputMedia), { url: oldToNewUrlMappings.get(outputMedia.url) }));
            }
        }
        this.outputMedias = newOutputMedias;
        return this;
    };
    DesignerCatalogResourcesBuilder.prototype.build = function () {
        return {
            id: this.designerCatalogId,
            configuration: this.configuration,
            resources: this.outputMedias
        };
    };
    return DesignerCatalogResourcesBuilder;
}());
exports.DesignerCatalogResourcesBuilder = DesignerCatalogResourcesBuilder;
